import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, IKeyValueInterface, WeGoAuthorizedLink, Permission, PermissionType, Entity } from '../../shared/config';
import { RoleAvailabilityModel } from '../../roleavailability/models/roleavailability.model';
import { retry } from 'rxjs/operator/retry';
import { PersonService } from '../../person/models/person.service';
import { AdminOfCompanyService } from '../models/admin-of-company.service';
import { AdminOfCompanyModel } from '../models/admin-of-company.model';
import { CompanyService } from '../../company/models/company.service';
import { CompanyAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';

@Component({
  selector: 'wego-admin-of-company',
  template: require('../views/admin-of-company-list.component.html'),
  providers: [AdminOfCompanyService, PersonService, CompanyService],

})
export class AdminOfCompanyListComponent implements OnInit {
  addCompanyAdminLink: any;
  inviteTitle: any;
  roleAvailabilityList: RoleAvailabilityModel[];
  DataListModel: DataListModel;
  sub: any;
  companyHashId: string;
  companyAdminList: AdminOfCompanyModel[];
  errorModel: IKeyValueInterface[];
  roleColumns: number = 0;
  ToggleRoleName: string;
  ToggleUserName: string;
  ToggleAddRole: boolean;
  ToggleRoleHashId: string;
  ToggleRolePersonHashID: string;
  toggleRoleMsg: string;
  toggleRoleTitle: string;
  apiErrorMsg: string;
  isLoading: boolean;
  deletePersonMasterHashId: string;
  resetPasswordPersonHashId: string;
  message: string;
  errorMessage: string;
  companyName: string;
  urlDefaultPage: string;
  urlCompanyList: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  validateMessage: string;
  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  private companyList: string;

  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('toggleRolePopup') public toggleRolePopup: any;
  @ViewChild('inviteAdminModal') public inviteAdminModal: any;

  constructor(private adminOfCompanyService: AdminOfCompanyService,
    private personService: PersonService,
    private companyService: CompanyService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService) {
  }

  get isAnyChecked(): boolean {
    if (this.companyAdminList) {
      let isCheck = this.companyAdminList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.companyAdminList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.companyAdminList) {
      return this.companyAdminList.some(x => x.isDeletable);
    }
    else { return false; }

  }

  ngOnInit() {
    this.module = this.translate.instant('LblCompanyAdmin');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.companyList = this.translate.instant('LblListPage', [this.translate.instant('LblCompany')]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlCompanyList = this.authService.GetURL(ApplicationRouteURL.URL_COMPANY_LIST);
    this.inviteTitle = this.translate.instant('LblInvite') + " " + this.translate.instant('LblCompanyAdmin');

    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.companyHashId = params['id'] || '';
        if (this.companyHashId != '') {

          this.addCompanyAdminLink = new WeGoAuthorizedLink("",
            Permission.PR_COMPANY_ADMIN, PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblInvite', Entity.COMPANY, this.companyHashId);

          this.GetCompanyDetails();
        }
      });
  }

  public RoleAvailabilityList() {
    this.isLoading = true;
    if (this.companyHashId) {
      this.adminOfCompanyService.GetAllRoleAvailability(new DataListModel(), this.companyHashId)
        .subscribe(
        res => {
          this.roleAvailabilityList = res.data;
          this.roleColumns = this.roleAvailabilityList.length;
          this.GetAdminOfCompanyList();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
    }
  }

  public GetCompanyDetails() {
    if (this.companyHashId) {
      this.isLoading = true;
      this.companyService.GetCompanyBasicDetail(this.companyHashId)
        .subscribe(
        res => {
          if (res.data) {
            this.companyName = res.data.entityName;
            this.RoleAvailabilityList();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
    }
  }

  public GetAdminOfCompanyList() {
    this.isLoading = true;
    this.adminOfCompanyService.GetAdminOfCompanyList(this.companyHashId, this.DataListModel)
      .subscribe(
      res => {
        this.companyAdminList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.companyAdminList = [];
        this.DataListModel.infoMessage = error;
        this.isLoading = false;
      });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetAdminOfCompanyList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetAdminOfCompanyList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetAdminOfCompanyList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetAdminOfCompanyList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.adminOfCompanyService.ExportAdminOfCompanyList(this.companyHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "CompanyAdmin" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public DeleteAdminOfCompany(deleteCompanyAdminList: string[]) {
    this.isLoading = true;
    this.adminOfCompanyService.DeleteAdminOfCompany(this.companyHashId, deleteCompanyAdminList)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetAdminOfCompanyList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnParentCheck(isChecked: boolean) {
    this.companyAdminList.filter(x => x.isDeletable).forEach(x => x.isChecked = isChecked);
  }

  public ShowAlertModal(deletePersonMasterHashId?: string): void {
    if (deletePersonMasterHashId) {
      this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deletePersonMasterHashId = deletePersonMasterHashId;
    }
    else {
      this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.deletePersonMasterHashId = "";
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteAdminOfCompanyList: any[];
    if (this.isMultipleDelete)
      deleteAdminOfCompanyList = this.companyAdminList.filter(x => x.isChecked).map(x => x.personMasterHashId);
    else
      deleteAdminOfCompanyList.push(this.deletePersonMasterHashId);

    this.DeleteAdminOfCompany(deleteAdminOfCompanyList);
    this.alertModal.hide();
  }

  // Add Instance admin popup
  public ShowAddCompanyAdminModal() {
    this.ShowInviteAdminModal();
  }

  public ToggleRoleAvailibility(personHashID: string, roleHashId: string, personRolesHashIds: string[], roleName: string, userName: string) {
    this.ToggleRolePersonHashID = personHashID;
    this.ToggleRoleHashId = roleHashId;
    this.ToggleUserName = userName;
    this.ToggleRoleName = roleName;

    if (this.CheckRole(personRolesHashIds, roleHashId)) {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [userName, roleName]);
      this.ToggleAddRole = false;
      this.ShowToggleRolePopup();
    } else {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [userName, roleName]);
      this.ToggleAddRole = true;
      this.ShowToggleRolePopup();
    }
  }

  public ShowToggleRolePopup(): void {
    this.toggleRolePopup.show();
  }

  public HideToggleRolePopup(): void {
    this.ToggleRolePersonHashID = '';
    this.ToggleRoleHashId = '';
    this.ToggleUserName = '';
    this.ToggleRoleName = '';

    this.toggleRolePopup.hide();
  }

  public ConfirmToggleRolePopup(): void {
    if (this.ToggleAddRole) {
      this.adminOfCompanyService.AddAdminOfInstanceRole(this.companyHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
        .subscribe(
        res => {
          this.GetAdminOfCompanyList();
          this.popupMsg = this.translate.instant('LblRoleAddedSuccess', [this.ToggleUserName, this.ToggleRoleName]);
          this.HideToggleRolePopup();
          this.ShowSuccessPopup();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
          this.HideToggleRolePopup();
        });
    } else {
      this.adminOfCompanyService.DeleteAdminOfInstanceRole(this.companyHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
        .subscribe(
        res => {
          this.GetAdminOfCompanyList();
          this.popupMsg = this.translate.instant('LblRoleDeletedSuccess', [this.ToggleUserName, this.ToggleRoleName]);
          this.HideToggleRolePopup();
          this.ShowSuccessPopup();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
          this.HideToggleRolePopup();
        });

    }
  }

  //Reset company admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }


  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = "";
    this.resetPasswordModal.hide();
  }
  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    console.log(this.resetPasswordPersonHashId);
    this.ResetPersonPassword(this.resetPasswordPersonHashId);
  }

  public ResendActivationMail(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.personService.ReSendActivationMail(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResendActivationMailSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResendActivationMailFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();

  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ShowInviteAdminModal(): void {
    this.inviteAdminModal.availableRoles = JSON.parse(JSON.stringify(this.roleAvailabilityList));
    this.inviteAdminModal.availablePersons = '';
    this.inviteAdminModal.show();
  }

  public HideInviteAdminModal(): void {
    this.inviteAdminModal.hide();
  }

  public SuccessInviteAdminModalClick($event: any): void {
    let adminInvitation = new CompanyAdminInvitationModel();
    adminInvitation.emailAddress = $event.emailAddress;
    adminInvitation.personHashId = $event.personHashId;
    adminInvitation.roleHashIdList = $event.roleHashIdList;
    adminInvitation.companyHashId = this.companyHashId;

    this.adminOfCompanyService.InviteAdminOfInstance(adminInvitation)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblInvitationMailSuccess');
          this.HideInviteAdminModal();
          this.ShowSuccessPopup();
        }
        else {
          this.inviteAdminModal.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
        this.HideInviteAdminModal();
      });
  }

  public SearchEmailAddress($event: any): void {
    let emailAddress = $event.emailAddress;
    this.isLoading = true;
    this.adminOfCompanyService.GetPersonListToInvite(this.companyHashId, emailAddress)
      .subscribe(
      res => {
        if (res.data) {
          this.inviteAdminModal.availablePersons = res.data;
          this.inviteAdminModal.errorModel = [];
        } else {
          this.inviteAdminModal.errorModel = res.error;
        }
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public CheckRole(existingArray: string[], currentRole: string) {
    return existingArray.some(x => x == currentRole);
  }

  
  get isResetCookieAccess(): boolean {
    if (this.companyAdminList) {
      return this.companyAdminList.some(x => !x.twoFaDisabled);
    } else {
      return false;
    }
  }

  get isTwoFaResetKeyAccess(): boolean {
    if (this.companyAdminList) {
      return this.companyAdminList.some(x => x.resetKeyEnabled);
    } else {
      return false;
    }
  }

  public ResetPersonCookies(personHashID: string) {
    ;
    this.personService.ResetTwoFaCookie(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblCookieResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblCookieResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ResetPersonTwoFA(personHashID: string) {

    this.personService.ResetTwoFaKey(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblKeyResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblKeyResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-company/components/admin-of-comapny-list.component.ts